import isEmpty from 'lodash/isEmpty'

import { User, UserType } from '@legacy/models/WhoAmI'

const passesUserType = (requiredUserTypes: UserType[] | undefined, authenticatedUser: User) => {
  if (isEmpty(requiredUserTypes)) return true

  return requiredUserTypes!.includes(authenticatedUser.type)
}

const passesRoles = (requiredRoles: string[] | undefined, authenticatedUser: User) => {
  if (isEmpty(requiredRoles)) return true

  return authenticatedUser.hasAnyRole(requiredRoles!)
}

export { passesUserType, passesRoles }
